import { REST_TAB_KEY } from '.';
import { FormattedModificationGroup } from '~Hooks/ItemModifications/useItemModifications';

export function getInitialSelectedGroupId(
  modificationGroups?: FormattedModificationGroup[],
  upsellGroups: { id: string }[] = [],
): string | null {
  const removableGroupWithoutGrid = modificationGroups?.find(
    (group) => !group.isGridViewEnabled && group.isRemovableIngredientGroup,
  );

  const amountOfGroupsWithoutGrid =
    modificationGroups?.filter((group) => !group.isGridViewEnabled).length ?? 0;

  /**
   * We have a removable ingredient group without grid view along with other groups that does not have grid view either
   * Then show rest...
   */
  if (removableGroupWithoutGrid && amountOfGroupsWithoutGrid > 1) {
    return REST_TAB_KEY;
  }

  /** If we only have one group that does not have grid view AND that group is a removable ingredient group - show that one first */
  if (removableGroupWithoutGrid) {
    return removableGroupWithoutGrid.id;
  }

  const gridViewGroup = modificationGroups?.find((group) => group.isGridViewEnabled);
  /** We have atleast one group with grid view, preselect the first one */
  if (gridViewGroup) {
    return gridViewGroup.id;
  }

  /** ELSE just take the first one of variationGroup / upsell */

  if (modificationGroups && modificationGroups.length > 0) {
    return modificationGroups[0].id;
  }

  if (upsellGroups.length > 0) {
    return upsellGroups[0].id;
  }

  return null;
}
